module.exports = __webpack_public_path__ + "media/images/swifticons/weather-default-8d18816ce4f247b51dab1e535bd4f92f.svg";